import MainContainer from '../main-container';
import Form from './legalProcessForm';
import List from './legalProcessList';
import { paths } from '../../config';

const settings = {
    pathRegister: paths.legalProcessRegister,
    pathList: paths.legalProcess,
    apiPath: 'legal-process',
    permissionAdmin: null,
    title: 'Processo',
    entity: 'legalProcess',
};

const LegalProcess: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};
const LegalProcessList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={{ ...settings, title: 'Processos' }} />
        </MainContainer>
    );
};

export { LegalProcess, LegalProcessList };
